import React, { useMemo } from "react";
import BottomBorderButton from "../button/bottomBorderButton";
//import Section from "components/section/section";
import Container from "components/sections/container";
import Image from "next/image";
import RichText from "components/sections/richText/richText";
import dayjs from "dayjs";
import { splitTitle } from "utils/utils";

const BlogHeader = ({
  category,
  link,
  date,
  title,
  description,
  imgSrc,
  externalLink,
}) => {
  const { mainTitle, subLink } = useMemo(() => {
    return splitTitle({ title });
  }, [title]);

  let formatDate = dayjs(new Date(date)).format("MMMM DD, YYYY");
  return (
    <Container additionalClass="bg-pale-green">
      <div className="flex flex-col items-center justify-start w-full h-full gap-4 py-6 mb-4 md:flex-row">
        <div className="w-full overflow-hidden">
          <Image
            src={imgSrc}
            alt="resource img"
            height={350}
            width={550}
            layout="responsive"
            className="items-start object-cover object-center transition-all hover:scale-105"
          />
        </div>
        <div className="flex flex-col items-start self-end w-full gap-2">
          <div
            className={`inline-block p-2 capitalize font-semibold mb-2 min-w-[120px] text-center bg-primary text-white`}
          >
            {category}
          </div>
          <p className="text-base font-normal">{formatDate}</p>
          <h4 className="font-bold text-left text-h4">{mainTitle}</h4>
          <p className="text-sm font-normal">
            {description && <RichText data={{ content: description }} />}
          </p>
          {externalLink ? (
            <BottomBorderButton
              value={"Apply To Job"}
              url={subLink || externalLink}
              external
            />
          ) : (
            (subLink || link) && (
              <BottomBorderButton value={"Read More"} url={subLink || link} />
            )
          )}
        </div>
      </div>
    </Container>
  );
};

export default BlogHeader;
